import React, { useEffect, useRef } from 'react';
import { WelcomeLogo } from '../WelcomeLogo';
import { useNotifications } from '@hooks/useNotifications';
import { useTranslation } from 'react-i18next';

export const OfflineScreen = () => {
    const { t } = useTranslation();
    const { showDefaultNotification } = useNotifications();
    const hasShown = useRef(false);

    useEffect(() => {
        if (!hasShown.current) {
            hasShown.current = true;
            showDefaultNotification({
                type: 'error',
                message: t('offline.message'),
            });
        }
    }, []);

    return (
        <div style={{ position: 'absolute', inset: 0, zIndex: 100 }}>
            <WelcomeLogo isVisible={true} />
        </div>
    );
};
